const e = {
  name: "Bookmark",
  dimensions: { width: 20, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 20 40" style="enable-background:new 0 0 20 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h20v40h-3.4L10,33.4L3.4,40H0V0z M2,2v36h0.6l7.4-7.4l7.4,7.4H18V2H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Bookmark
};
